import { Skeleton } from '@/components/ui/skeleton';

/** Shown while a split route chunk loads. Shaped like the screens it precedes. */
export function RouteFallback() {
  return (
    <div className="space-y-5 p-6">
      <div className="space-y-2">
        <Skeleton className="h-3 w-24" />
        <Skeleton className="h-6 w-56" />
      </div>
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
        {Array.from({ length: 4 }).map((_, index) => (
          <Skeleton key={index} className="h-20 rounded-md" />
        ))}
      </div>
      <Skeleton className="h-72 rounded-md" />
    </div>
  );
}
